'use client'

import { createContext, useContext, useState, type ReactNode } from 'react'

interface NavbarExtrasContextType {
  searchContent: ReactNode | null
  setSearchContent: (content: ReactNode | null) => void
  checkoutRight: ReactNode | null
  setCheckoutRight: (content: ReactNode | null) => void
}

const NavbarExtrasContext = createContext<NavbarExtrasContextType>({
  searchContent: null,
  setSearchContent: () => {},
  checkoutRight: null,
  setCheckoutRight: () => {},
})

export function NavbarExtrasProvider({ children }: { children: ReactNode }) {
  const [searchContent, setSearchContent] = useState<ReactNode | null>(null)
  const [checkoutRight, setCheckoutRight] = useState<ReactNode | null>(null)

  return (
    <NavbarExtrasContext.Provider value={{ searchContent, setSearchContent, checkoutRight, setCheckoutRight }}>
      {children}
    </NavbarExtrasContext.Provider>
  )
}

export function useNavbarExtras() {
  return useContext(NavbarExtrasContext)
}
